module.exports = __webpack_public_path__ + "static/media/draw-square.7f52a80f.svg";